var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYnft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 74,
    viewBox: "0 0 176 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0667 4.03638L35.2333 17.5246L39.5 19.7446L26.8333 43.7609L24.9 18.4664H14.2L19.5333 56.98C18.9 58.6618 18.2 59.8727 17.5 60.68C16.8667 61.42 16.0333 61.9582 15.1 62.2609C14.8 62.3618 14.5 62.4291 14.2 62.4627C11.1333 62.4627 8.33332 62.4964 8.33332 62.4964L3.79999 70.3C3.79999 70.3 4.13332 70.3673 14.2 70.3673C15.5333 70.3337 16.8333 70.1655 18.1 69.8291C19.5667 69.4591 20.9 68.7527 22 67.7436C23.1333 66.6673 24.3667 65.12 25.6667 63.0682C26.9667 61.0164 28.5 58.2582 30.3667 54.8946L47.6 23.9827L52.1 26.3373L52.0667 4.03638Z",
    stroke: "#00FFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7333 8.6109L82 38.48H82.1333L88.1 8.6109H96.5L87.6667 50.5891H78.5333L67.1 21.1236H66.9667L61 50.5891H52.5L61.2333 8.6109H70.7333Z",
    stroke: "#00FFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.4 16.3809H111.033L108.967 26.1018H126.8L125.3 33.2663H107.533L103.867 50.6227H94.7667L103.5 8.64453H133.1L131.4 16.3809Z",
    stroke: "#00FFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.167 16.3809L137.8 8.6109H172.533L170.9 16.3809H158.433L151.333 50.6227H142.133L149.233 16.3809H136.167Z",
    stroke: "#00FFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYnft);
export default __webpack_public_path__ + "static/media/ynft.226944d8155a10ae3a82dc18c3afe4d4.svg";
export { ForwardRef as ReactComponent };